@if (_active) {
  <kendo-window
    title="{{ _isNew ? 'Add new record' : 'Edit' }}"
    (close)="_closeForm()"
    (stateChange)="_onStateChanges($event)"
    >
    <form novalidate [formGroup]="_form">
      <div class="row mobileProjectForm">
        <div class="col-12">
          <div class="bordered_sections">
            <div class="col-12 import_title">Follow the Steps</div>
            <div class="col-12 buttonsSection"
              style="margin-top: 10px">
              <button
                kendoButton
                class="steps_buttons_class"
                (click)="_onSave($event)"
                >
                <img
                  class="backimage"
                  [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'"
                  />
                  <span>Save</span>
                </button>
                @if (currentStep < 4 && _canGoNext) {
                  <button kendoButton
                    class="steps_buttons_class"
                    (click)="_next()">
                    <img class="backimage"
                      [src]="'/assets/menu/'+ _theme +'/next-icon.svg'" />
                      <span>Next</span>
                    </button>
                  }
                  @if (currentStep > 0) {
                    <button kendoButton
                      class="steps_buttons_class"
                      (click)="_back()">
                      <img class="backimage"
                        [src]="'/assets/menu/'+ _theme +'/back-icon.svg'" />
                        <span>Back</span>
                      </button>
                    }
                  </div>
                  <br/>
                  <kendo-stepper
                    [steps]="_steps"
                    [stepType]="'full'"
                    [(currentStep)]="currentStep"
                    [linear]="false"
                    >
                  </kendo-stepper>
                </div>
              </div>
              <div class="col-12">
                <div class="row stepsRowMargin">
                  <div class="col-12 col-md-4 stepsColPadding">
                    <div class="row">
                      <div class="col-12">
                        <p class="step_title">
                          Step 1:
                          <span class="stepDescription">Enable/Disable Group</span>
                        </p>
                      </div>
                      <div class="col-12">
                        <div
                          class="bordered_sections_special min-height-section"
                          [class.active-step-mobile]="currentStep === 0"
                          >
                          @if (currentStep !== 0) {
                            <div class="mobile-overlay"></div>
                          }
                          <div class="row">
                            <div class="col-12">
                              <input
                                type="checkbox"
                                kendoCheckBox
                                formControlName="enableGroup"
                                />
                                <label class="k-radio-label mobileCheckboxLabel"
                                  >Enable Group</label
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-8 stepsColPadding">
                        <div class="row">
                          <div class="col-12">
                            <p class="step_title">
                              Step 2:
                              <span class="stepDescription">choose a group name</span>
                            </p>
                          </div>
                          <div class="col-12">
                            <div
                              class="bordered_sections_special bordered_sections_special_right min-height-section"
                              [class.active-step-mobile]="currentStep === 1"
                              >
                              @if (currentStep !== 1) {
                                <div class="mobile-overlay"></div>
                              }
                              <div class="row">
                                <div class="col-12">
                                  <div class="form-group">
                                    <label class="control-label trl">Group Name</label>
                                    <input
                                      type="text"
                                      class="k-textbox writebox"
                                      formControlName="name"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row stepsRowMargin">
                        <div class="col-12 col-md-6 stepsColPadding">
                          <div class="row">
                            <div class="col-12">
                              <p class="step_title">
                                Step 3:
                                <span class="stepDescription">choose data sync mode</span>
                              </p>
                            </div>
                            <div class="col-12">
                              <div
                                class="bordered_sections_special min-height-section-large"
                                [class.active-step-mobile]="currentStep === 2"
                                >
                                @if (currentStep !== 2) {
                                  <div class="mobile-overlay"></div>
                                }
                                <div class="row">
                                  <div class="col-12 margin-bottom">
                                    <input
                                      type="radio"
                                      kendoRadioButton
                                      formControlName="enableOfflineMode"
                                      (change)="_enableOfflineModeChecked($event)"
                                      />
                                      <label class="k-radio-label mobileRadioLabel"
                                        >Enable Offline Mode</label
                                        >
                                      </div>
                                      <div class="col-12 margin-bottom">
                                        <div class="padding-left-div">
                                          <input
                                            type="checkbox"
                                            kendoCheckBox
                                            formControlName="enableOfflineModeWithAuth"
                                            (change)="_enableOfflineModeWithAuthChecked(this)"
                                            />
                                            <label class="k-radio-label mobileCheckboxLabelgray"
                                              >with authentication</label
                                              >
                                            </div>
                                          </div>
                                          <div class="col-12">
                                            <p class="italicgraytext">
                                              *Lorem ipsum is simply dummy text of the printing
                                            </p>
                                          </div>
                                          <div class="col-12">
                                            <div class="graySeparatorBorder"></div>
                                          </div>
                                          <div class="col-12 margin-bottom">
                                            <input
                                              type="radio"
                                              kendoRadioButton
                                              formControlName="enableOnlineMode"
                                              (change)="_enableOnlineModeChecked(this)"
                                              />
                                              <label class="k-radio-label mobileRadioLabel"
                                                >Enable Online Mode</label
                                                >
                                              </div>
                                              <div class="col-12 margin-bottom">
                                                <div class="padding-left-div">
                                                  <input
                                                    type="checkbox"
                                                    kendoCheckBox
                                                    formControlName="enableOnlineModeSync"
                                                    (change)="_enableOnlineModeSyncChecked(this)"
                                                    />
                                                    <label class="k-radio-label mobileCheckboxLabelgray"
                                                      >Background Sync/login Sync</label
                                                      >
                                                    </div>
                                                  </div>
                                                  <div class="col-12">
                                                    <p class="italicgraytext">
                                                      *The Data will automatically sync every night on
                                                      midnight
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-12 col-md-6 stepsColPadding">
                                          <div class="row">
                                            <div class="col-12">
                                              <p class="step_title">
                                                Step 4:
                                                <span class="stepDescription"
                                                  >choose the inventory transactions</span
                                                  >
                                                </p>
                                              </div>
                                              <div class="col-12">
                                                <div
                                                  class="bordered_sections_special bordered_sections_special_right min-height-section-large"
                                                  [class.active-step-mobile]="currentStep === 3"
                                                  >
                                                  @if (currentStep !== 3) {
                                                    <div class="mobile-overlay"></div>
                                                  }
                                                  <div class="row">
                                                    <div class="col-12 margin-bottom">
                                                      <input
                                                        type="checkbox"
                                                        kendoCheckBox
                                                        formControlName="chooseReceive"
                                                        />
                                                        <label class="k-radio-label mobileCheckboxLabel"
                                                          >Receive</label
                                                          >
                                                        </div>
                                                        <div class="col-12 margin-bottom">
                                                          <input
                                                            type="checkbox"
                                                            kendoCheckBox
                                                            formControlName="chooseMove"
                                                            />
                                                            <label class="k-radio-label mobileCheckboxLabel"
                                                              >Move</label
                                                              >
                                                            </div>
                                                            <div class="col-12 margin-bottom">
                                                              <input
                                                                type="checkbox"
                                                                kendoCheckBox
                                                                formControlName="choosePhysicalInventory"
                                                                />
                                                                <label class="k-radio-label mobileCheckboxLabel"
                                                                  >Physical Inventory</label
                                                                  >
                                                                </div>
                                                                <div class="col-12 margin-bottom">
                                                                  <input
                                                                    type="checkbox"
                                                                    kendoCheckBox
                                                                    formControlName="chooseDispose"
                                                                    />
                                                                    <label class="k-radio-label mobileCheckboxLabel"
                                                                      >Dispose</label
                                                                      >
                                                                    </div>
                                                                    <div class="col-12 margin-bottom">
                                                                      <input
                                                                        type="checkbox"
                                                                        kendoCheckBox
                                                                        formControlName="chooseIssue"
                                                                        />
                                                                        <label class="k-radio-label mobileCheckboxLabel"
                                                                          >Issue</label
                                                                          >
                                                                        </div>
                                                                        <div class="col-12 margin-bottom">
                                                                          <input
                                                                            type="checkbox"
                                                                            kendoCheckBox
                                                                            formControlName="choosePack"
                                                                            />
                                                                            <label class="k-radio-label mobileCheckboxLabel"
                                                                              >Pack</label
                                                                              >
                                                                            </div>
                                                                            <div class="col-12 margin-bottom">
                                                                              <input
                                                                                type="checkbox"
                                                                                kendoCheckBox
                                                                                formControlName="chooseShip"
                                                                                />
                                                                                <label class="k-radio-label mobileCheckboxLabel"
                                                                                  >Ship</label
                                                                                  >
                                                                                </div>
                                                                                <div class="col-12 margin-bottom">
                                                                                  <input
                                                                                    type="checkbox"
                                                                                    kendoCheckBox
                                                                                    formControlName="chooseReturn"
                                                                                    />
                                                                                    <label class="k-radio-label mobileCheckboxLabel"
                                                                                      >Return</label
                                                                                      >
                                                                                    </div>
                                                                                  </div>
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div class="col-12">
                                                                        <div class="row stepsRowMargin">
                                                                          <div class="col-12 stepsColPadding">
                                                                            <div class="row">
                                                                              <div class="col-12">
                                                                                <!-- <button
                                                                                kendoButton
                                                                                class="steps_buttons_class"
                                                                                (click)="_onSave($event)"
                                                                                >
                                                                                <img
                                                                                  class="backimage"
                                                                                  [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'"
                                                                                  />
                                                                                  <span>Save</span>
                                                                                </button> -->
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                    @if (false) {
                                                                      <input
                                                                        type="checkbox"
                                                                        kendoCheckBox
                                                                        formControlName="isAsset"
                                                                        />
                                                                    }
                                                                    <!-- <div class="row">
                                                                    <div class="col-12">
                                                                      <asap-forms-validation-summary *ngIf="_invalidForm" [form]="_form" [page]="'mobileAppGroups'">
                                                                      </asap-forms-validation-summary>
                                                                    </div>
                                                                  </div> -->
                                                                </form>
                                                              </kendo-window>
                                                            }
